import moment from "moment";
import { useState, useEffect, useMemo } from "react";
import {
  myTasks5WayListName,
  myTasksSDCA5WayListName,
} from "src/api/config/myTasks5Way.config";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import Loading from "src/components/Loading";
import {
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { TooltipItem } from "src/utils/Tooltip";
import { twMerge } from "tailwind-merge";
import { Statuses5WayNotice } from "../statusesNotice/statusesNotice";
import {
  myTasksIncidentsStatusesListName,
  myTasksIncidentstListName,
} from "src/api/config/myTasksInc.config";
import {
  actionsStatus,
  FiveWhyType,
  incStatus,
  incTypes,
  isStrapi,
} from "src/api/config/systemSwitch";
import { emailsSender, siteUrl } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";
import { mode } from "src/constants";
import { emailQueueListName } from "src/api/config/email.config";
const { sendEmail } = emailAPI();

const Statuses = ({ incidentID }: any) => {
  const [color, setColor] = useState("#FCD34D");
  const [statuses, setStatuses] = useState<any>([]);
  const [card5Way, setCard5Way] = useState<any>(null);
  const [incCard, setIncCard] = useState<any>(null);
  const [actions, setActions] = useState<any>([]);
  const [status, setStatus] = useState<any>(null);
  const [getAll, setGetAll] = useState(false);
  const [getCardsData, setGetCardsData] = useState(false);
  const users: any = useAppSelector(selectUsers);

  useEffect(() => {
    getItemsRequest({ listName: myTasksIncidentsStatusesListName }).then(
      (results) => {
        setStatuses(results.items);
        getItemsRequest({
          listName: myTasksIncidentstListName,
          filters: { ID: incidentID },
        }).then((results) => {
          setIncCard(results.items.length > 0 && results.items[0]);
          const tempIncCard = results.items[0];
          getItemsRequest({
            listName: myTasks5WayListName,
            filters: { Incident: tempIncCard.ID },
          }).then((results) => {
            setCard5Way(results.items.length > 0 && results.items[0]);
            setGetCardsData(true);
          });
        });
      }
    );
  }, []);

  useEffect(() => {
    if (getCardsData) {
      setActions([]);
      if (card5Way) {
        getItemsRequest({
          listName: myTasksSDCA5WayListName,
          filters: { _x0035_Way: card5Way.ID },
        }).then((results) => {
          let arrRequests: any = [],
            tempActions: any = [];
          if (card5Way.Type5Way === FiveWhyType) {
            arrRequests = [
              ...arrRequests,
              getItemsRequest({
                listName: myTaskActionsListName,
                filters: {
                  ImportantHashTag: `#5Почему_${card5Way.ID}*`,
                },
              }),
            ];
          } else {
            results.items.map((item) => {
              arrRequests = [
                ...arrRequests,
                getItemsRequest({
                  listName: myTaskActionsListName,
                  filters: {
                    ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
                  },
                }),
              ];
            });
          }
          const tempTypeIncCard: string = JSON.parse(incCard.Questions)[
            "IncidentOption"
          ];
          if (tempTypeIncCard === "Несоответствие") {
            getItemsRequest({
              listName: myTaskActionsListName,
              filters: {
                ImportantHashTag: `#${tempTypeIncCard}_${incCard[
                  "TypeIncident"
                ].get_lookupValue()}_${incCard.ID}*`.toLowerCase(),
              },
            }).then((results) => {
              tempActions = [...results.items];
              if (arrRequests.length > 0) {
                Promise.all(arrRequests).then((values) => {
                  values.forEach((value) => {
                    tempActions = [...tempActions, ...value.items];
                  });
                  setActions([...tempActions]);
                  setGetAll(true);
                });
              } else {
                setActions([...tempActions]);
                setGetAll(true);
              }
            });
          } else {
            if (arrRequests.length > 0) {
              Promise.all(arrRequests).then((values) => {
                values.map((value) => {
                  tempActions = [...tempActions, ...value.items];
                });
                setActions([...tempActions]);
                setGetAll(true);
              });
            } else {
              setGetAll(true);
            }
          }
        });
      }
      if (!card5Way) {
        if (incCard.Questions) {
          let tempActions: any = [];
          const tempTypeIncCard: string = JSON.parse(incCard.Questions)[
            "IncidentOption"
          ];
          if (tempTypeIncCard === "Несоответствие") {
            getItemsRequest({
              listName: myTaskActionsListName,
              filters: {
                ImportantHashTag: `#${tempTypeIncCard}_${incCard[
                  "TypeIncident"
                ].get_lookupValue()}_${incCard.ID}*`.toLowerCase(),
              },
            }).then((results) => {
              tempActions = [...results.items];
              setActions([...tempActions]);
              setGetAll(true);
            });
          } else {
            setGetAll(true);
          }
        }
      }
    }
  }, [getCardsData]);

  useEffect(() => {
    if (getAll) {
      const tempTypeIncCard: string = JSON.parse(incCard.Questions)[
        "IncidentOption"
      ];
      if (
        incCard.Status.get_lookupId() === incStatus.finish ||
        incCard.Status.get_lookupId() === incStatus.cancel
      ) {
        setStatus(
          statuses.find(
            (status: any) => status.ID === incCard.Status.get_lookupId()
          )
        );
      } else if (
        (incCard.Fixed ||
          (actions.length > 0 &&
            actions.filter(
              (action: any) =>
                action.Status.get_lookupId() !== actionsStatus.cancel &&
                action.Status.get_lookupId() !== actionsStatus.closed
            ).length === 0 &&
            actions.filter(
              (action: any) =>
                action.Status.get_lookupId() === actionsStatus.closed
            ).length > 0)) &&
        tempTypeIncCard === "Несоответствие"
      ) {
        setStatus(
          statuses.find((status: any) => status.ID === incStatus.closed)
        ); // Закрыто
      } else if (
        moment(new Date()).startOf("day").unix() >
        moment(incCard.ClosedDate).startOf("day").unix()
      ) {
        setStatus(statuses.find((status: any) => status.ID === incStatus.old)); // Просрочено
      } else if (
        moment(new Date()).startOf("day").unix() <=
        moment(incCard.ClosedDate).startOf("day").unix()
      ) {
        setStatus(
          statuses.find((status: any) => status.ID === incStatus.process)
        ); // В процессе
      }
    }
  }, [getAll]);

  useEffect(() => {
    if (status) {
      updateItemRequest({
        listName: myTasksIncidentstListName,
        body: { ID: incidentID, Status: status.ID },
      }).then(() => {
        localStorage.setItem("UPDATE_STATUS_INC", "true");
        const tempTypeIncCard: string = JSON.parse(incCard.Questions)[
          "IncidentOption"
        ];
        if (
          emailsSender &&
          status.ID === incStatus.old &&
          incCard.Status.get_lookupId() !== incStatus.old &&
          tempTypeIncCard === "Инцидент"
        ) {
          let emailsHanleArr: any = [];
          const dateSendEmailsArr = [
            moment(new Date()).clone().subtract(12, "hours").toDate(),
            moment(new Date()).clone().add(1440, "m").toDate(),
          ];
          dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
            const emailBody = {
              Body: `Здравствуйте ${users[incCard.ResponsibleEmail] &&
                users[incCard.ResponsibleEmail]["displayName"]
                },<br/><br/>Примите во внимание, что инцидент <a href="${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID
                }">${incCard.Description && incCard.Description.slice(0, 20)
                }...</a> перешел в статус «Просрочено», т.к. закончился срок расследования`,
              DateToBeSentAt: date,
              Title: "Мои Задачи | Просрочено расследование инцидента",
              Subject: "Мои Задачи | Просрочено расследование инцидента",
              Recepients: incCard.ResponsibleEmail,
              RepeatAt: (idxDate === 1 && 1440) || 0,
              CheckDoc: `old_inc_${incCard.ID}`,
            };
            emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
          });
          Promise.all(emailsHanleArr);
        }
        if (status.ID == incStatus.finish || status.ID === incStatus.cancel) {
          getItemsRequest({
            listName: emailQueueListName,
            filters: { CheckDoc: `old_inc_${incCard.ID}` },
          }).then((results) => {
            const { items } = results;
            let removeEmails: any = [];
            items.forEach((item) => {
              removeEmails = [...removeEmails, { ID: item.ID }];
            });
            if (removeEmails.length > 0) {
              deleteItemRequest({
                listName: emailQueueListName,
                ID: 0,
                Ids: removeEmails,
              }).then((results) => {
                console.log("Письма удалены");
              });
            }
          });
        }
      });
    }
  }, [status]);

  return (
    <>
      {(!status && (
        <FlexCol className="h-[32px] w-[32px]">
          <Loading />
        </FlexCol>
      )) || (
          <TooltipItem
            wrapperClassName="flex justify-end"
            position="bottom-left"
            tooltipsReactNode={
              <Statuses5WayNotice
                statuses={statuses}
                typeInc={
                  (incCard && JSON.parse(incCard.Questions)["IncidentOption"]) ||
                  ""
                }
              />
            }
            tooltipsText=""
            className="w-[600px]"
          >
            <FlexRow
              style={{ backgroundColor: status.Color }}
              className={twMerge(
                `text-white py-[5px] px-[14px] rounded-md font-bold h-fit w-fit`
              )}
            >
              {status.Title}
            </FlexRow>
          </TooltipItem>
        )}
    </>
  );
};

export default Statuses;
